import runAfterPageLoad from "../runAfterPageLoad";

export default function loadModernComponentsFormMultiselect() {
  runAfterPageLoad(() => {
    $(".modern-components-form-multiselect:not(.hidden)").each((idx, item) => {
      initializeNewSelect2Multiselect($(item));
    });
  });
}

function initializeNewSelect2Multiselect(element) {
  element.select2({
    multiple: true,
    theme: "bootstrap",
    width: "100%",
  });
}
